import dayjs from 'dayjs';

export const selectedMonthAndYear = (month, year) => {
  let startTime, endTime;

  if (month === '0') {
    startTime = dayjs(`${year}-01-01`).startOf('year').toISOString();
    endTime = dayjs(`${year}-12-31`).endOf('year').toISOString();
  } else {
    startTime = dayjs(`${year}-${month}-01`).startOf('month').toISOString();
    endTime = dayjs(`${year}-${month}-01`).endOf('month').toISOString();
  }

  return {
    startTime,
    endTime,
  };
};

export const getLast7Days = () => {
  return Array.from({ length: 8 }, (_, index) =>
    dayjs().subtract(index, 'day').format('D/M')
  ).reverse();
};

export const getLast12Months = () => {
  return Array.from({ length: 12 }, (_, index) =>
    dayjs().subtract(index, 'month').format('M/YYYY')
  ).reverse();
};

export const getCurrentMonth = () => dayjs().month() + 1;
export const getCurrentYear = () => dayjs().year();
